import { type } from "arktype";
import type { Tier } from "./vocabulary";

export const planIds = ["solo", "studio", "practice", "team"] as const;
export const PlanId = type("'solo' | 'studio' | 'practice' | 'team'");
export type PlanId = typeof PlanId.infer;

/** `tier_1` and `free_period` are deliberately absent: not purchasable (R-BIL-01). */
export type PurchasableTier = Extract<Tier, "tier_2_5" | "tier_6_10" | "tier_11_25" | "tier_26_plus">;

export const PLAN_CATALOG = [
  { id: "solo",     name: "Solo",     priceUsdPerYear: 290,  clientLimit: 5,    tier: "tier_2_5" },
  { id: "studio",   name: "Studio",   priceUsdPerYear: 540,  clientLimit: 10,   tier: "tier_6_10" },
  { id: "practice", name: "Practice", priceUsdPerYear: 990,  clientLimit: 25,   tier: "tier_11_25" },
  { id: "team",     name: "Team",     priceUsdPerYear: 1790, clientLimit: null, tier: "tier_26_plus" },
] as const satisfies readonly { id: PlanId; name: string; priceUsdPerYear: number; clientLimit: number | null; tier: PurchasableTier }[];

// Stripe owns this vocabulary; kept as data so a new status never requires a code change.
export const billingStatuses = ["trialing", "active", "past_due", "canceled", "unpaid", "incomplete", "incomplete_expired"] as const;
export type BillingStatus = (typeof billingStatuses)[number];
